import { useEffect, useRef } from "react";

const SPOTLIGHT_PADDING = 8;
const SPOTLIGHT_RADIUS = 12;
const OVERLAY_Z_INDEX = 999999;

interface TourOverlayProps {
  targetRect: DOMRect | null;
  onBackdropClick: () => void;
}

const TourOverlay = ({ targetRect, onBackdropClick }: TourOverlayProps) => {
  const onBackdropClickRef = useRef(onBackdropClick);
  onBackdropClickRef.current = onBackdropClick;

  useEffect(() => {
    if (!targetRect) return;

    const t = targetRect.top - SPOTLIGHT_PADDING;
    const l = targetRect.left - SPOTLIGHT_PADDING;
    const r = targetRect.right + SPOTLIGHT_PADDING;
    const b = targetRect.bottom + SPOTLIGHT_PADDING;

    const handleClick = (e: MouseEvent) => {
      const { clientX: x, clientY: y } = e;

      if (x >= l && x <= r && y >= t && y <= b) return;

      const tooltip = document.querySelector(".tour-custom-tooltip");
      if (tooltip?.contains(e.target as HTMLElement)) return;

      e.stopPropagation();
      e.preventDefault();
      onBackdropClickRef.current();
    };

    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, [targetRect]);

  if (!targetRect) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: targetRect.top - SPOTLIGHT_PADDING,
        left: targetRect.left - SPOTLIGHT_PADDING,
        width: targetRect.width + SPOTLIGHT_PADDING * 2,
        height: targetRect.height + SPOTLIGHT_PADDING * 2,
        borderRadius: SPOTLIGHT_RADIUS,
        boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.5), 0 0 0 3px rgba(71, 68, 229, 0.35)",
        zIndex: OVERLAY_Z_INDEX,
        pointerEvents: "none",
        transition: "all 0.3s ease",
      }}
    />
  );
};

export default TourOverlay;
